/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";
import React from "react";

export const DeliveryNoteRowSkeleton = (props) => (
    <ContentLoader
        width={"100%"}
        height={80}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{borderBottom: SkeletonSettings.BORDER}}
        {...props}>

        {/* Delivery number */}
        <rect x="0" y={`calc(50% - 15px)`} rx="3" ry="3" width="20%" height="10"/>
        <rect x="0" y={`calc(50% + 5px)`} rx="3" ry="3" width="20%" height="10"/>

        {/* Ship to */}
        <rect x={`calc(35% + 10px)`} y={`calc(50% - 15px)`} rx="3" ry="3" width="10%" height="10"/>
        <rect x={`calc(35% + 10px)`} y={`calc(50% + 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* City */}
        <rect x={`calc(50% + 20px)`} y={`calc(50% - 15px)`} rx="3" ry="3" width="10%" height="10"/>
        <rect x={`calc(50% + 20px)`} y={`calc(50% + 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Goods issue date */}
        <rect x={`calc(65% + 20px)`} y={`calc(50% - 15px)`} rx="3" ry="3" width="10%" height="10"/>
        <rect x={`calc(65% + 20px)`} y={`calc(50% + 5px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Download */}
        <rect x={"85%"} y={`calc(50% - 20px)`} rx="3" ry="3" width="15%" height="40"/>

    </ContentLoader>
);
